import { Component, EventEmitter, HostListener, Input, OnInit, Output, Sanitizer } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { TaskModel } from '../../task.model';
import { MatDialogRef } from '@angular/material/dialog';
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { ErrorStateMatcher } from '@angular/material/core';

/** Error when invalid control is dirty, touched, or submitted. */
export class TaskNameErrorMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-task-creator-name',
  templateUrl: 'task.creator.name.component.html',
  styleUrls: ['task.creator.name.component.scss']
})
export class TaskCreatorNameComponent implements OnInit {

  faEdit = faEdit;
  faPlus = faPlus;
  taskNameFormControl = new FormControl('', [Validators.required]);
  matcher = new TaskNameErrorMatcher();


  constructor(
    public taskModel: TaskModel,
    private dialogRef: MatDialogRef<TaskCreatorNameComponent>,

  ) { }

  ngOnInit() {
  }

  cancel() {
    this.dialogRef.close(false);
  }

  confirm() {
    if (this.validate())
      this.dialogRef.close(true);
  }

  validate() {
    this.taskNameFormControl.markAllAsTouched();
    return this.taskNameFormControl.valid;
  }

}
